import "./index.moduleRenamed.css";

export const editModalContext = "index-module__editModalContext___53GwI";
export const templatePanel = "index-module__templatePanel___ohh9H";
export const templatePanelButtonGroup = "index-module__templatePanelButtonGroup___OVPYS";
export const createNewButton = "index-module__createNewButton___Ybowf";
export const openManageButton = "index-module__openManageButton___MY-hD";
export const templateSelector = "index-module__templateSelector___tcK7b";
export const manageModalContext = "index-module__manageModalContext___8TF-K";
export const manageModalTable = "index-module__manageModalTable___mp59b";
export const manageModalEdit = "index-module__manageModalEdit___HP8oK";
export const manageModalDiv = "index-module__manageModalDiv___bCEfK";
export const manageModalEmptyEditPlaceholder = "index-module__manageModalEmptyEditPlaceholder___PVxbd";

export default {
  editModalContext: "index-module__editModalContext___53GwI",
  templatePanel: "index-module__templatePanel___ohh9H",
  templatePanelButtonGroup: "index-module__templatePanelButtonGroup___OVPYS",
  createNewButton: "index-module__createNewButton___Ybowf",
  openManageButton: "index-module__openManageButton___MY-hD",
  templateSelector: "index-module__templateSelector___tcK7b",
  manageModalContext: "index-module__manageModalContext___8TF-K",
  manageModalTable: "index-module__manageModalTable___mp59b",
  manageModalEdit: "index-module__manageModalEdit___HP8oK",
  manageModalDiv: "index-module__manageModalDiv___bCEfK",
  manageModalEmptyEditPlaceholder: "index-module__manageModalEmptyEditPlaceholder___PVxbd",
};